<template><svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 384 384"
>
			<rect x="0" y="277.333" width="128" height="42.667"/>
			<rect x="0" y="170.667" width="256" height="42.667"/>
			<rect x="0" y="64" width="384" height="42.667"/>
</svg>
</template>